module.exports = function () { return this }



//////////////////
// WEBPACK FOOTER
// ./~/empty-functions/returns-this.js
// module id = 24
// module chunks = 0